import { User, Post, Category, Brand, Message } from '../types';

// Mock Users
export const mockUsers: User[] = [
  {
    id: 'u1',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@email.com',
    joinDate: '2024-01-15',
    isVerified: true,
    sellerStatus: 'verified',
  },
  {
    id: 'u2',
    firstName: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@email.com',
    joinDate: '2024-02-20',
    isVerified: true,
    sellerStatus: 'verified',
  },
  {
    id: 'u3',
    firstName: 'Mike',
    lastName: 'Johnson',
    email: 'mike.johnson@email.com',
    joinDate: '2024-03-10',
    isVerified: true,
    sellerStatus: 'pending',
  },
];

// Mock Categories
export const mockCategories: Category[] = [
  { id: 'c1', name: 'Rackets', description: 'Tennis rackets and frames' },
  { id: 'c2', name: 'Shoes', description: 'Tennis shoes and court footwear' },
  { id: 'c3', name: 'Apparel', description: 'Tennis clothing and accessories' },
  { id: 'c4', name: 'Strings & Grips', description: 'Tennis strings, grips, and accessories' },
  { id: 'c5', name: 'Balls', description: 'Tennis balls and practice equipment' },
  { id: 'c6', name: 'Bags', description: 'Tennis bags and equipment storage' },
];

// Mock Brands
export const mockBrands: Brand[] = [
  { id: 'b1', name: 'Wilson', description: 'Premium tennis equipment' },
  { id: 'b2', name: 'Babolat', description: 'Professional tennis gear' },
  { id: 'b3', name: 'Head', description: 'Tennis rackets and accessories' },
  { id: 'b4', name: 'Nike', description: 'Tennis shoes and apparel' },
  { id: 'b5', name: 'Adidas', description: 'Tennis clothing and footwear' },
  { id: 'b6', name: 'Yonex', description: 'Tennis rackets and strings' },
];

// Mock Posts
export const mockPosts: Post[] = [
  {
    id: 'p1',
    title: 'Wilson Pro Staff Tennis Racket',
    description: 'Professional grade tennis racket, used for one season. Great condition, perfect for intermediate to advanced players. Grip size 4 3/8.',
    price: 89.99,
    condition: 'excellent',
    images: ['https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c1',
    brandId: 'b1',
    sellerId: 'u1',
    status: 'active',
    createdAt: '2024-05-20T10:00:00Z',
    updatedAt: '2024-05-20T10:00:00Z',
    location: 'San Francisco, CA',
  },
  {
    id: 'p2',
    title: 'Nike Court Tennis Shoes',
    description: 'Barely worn Nike Court tennis shoes, size 10. Perfect for hard court play with excellent grip and comfort.',
    price: 65.00,
    condition: 'like-new',
    images: ['https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c2',
    brandId: 'b4',
    sellerId: 'u2',
    status: 'active',
    createdAt: '2024-05-19T14:30:00Z',
    updatedAt: '2024-05-19T14:30:00Z',
    location: 'Los Angeles, CA',
  },
  {
    id: 'p3',
    title: 'Babolat Pure Drive Racket',
    description: 'Babolat Pure Drive tennis racket with fresh strings. Great power and spin, perfect for aggressive players.',
    price: 149.99,
    condition: 'good',
    images: ['https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c1',
    brandId: 'b2',
    sellerId: 'u3',
    status: 'active',
    createdAt: '2024-05-18T09:15:00Z',
    updatedAt: '2024-05-18T09:15:00Z',
    location: 'Austin, TX',
  },
  {
    id: 'p4',
    title: 'Adidas Tennis Polo Shirt',
    description: 'Professional tennis polo shirt, size M. Moisture-wicking fabric, worn only a few times.',
    price: 25.00,
    condition: 'excellent',
    images: ['https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c3',
    brandId: 'b5',
    sellerId: 'u1',
    status: 'sold',
    createdAt: '2024-05-15T16:45:00Z',
    updatedAt: '2024-05-22T11:20:00Z',
    location: 'Seattle, WA',
  },
  {
    id: 'p5',
    title: 'Head Tennis Bag',
    description: 'Head tennis bag with multiple compartments. Fits 6 rackets plus shoes and accessories. Excellent condition.',
    price: 75.00,
    condition: 'excellent',
    images: ['https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c6',
    brandId: 'b3',
    sellerId: 'u2',
    status: 'active',
    createdAt: '2024-05-22T08:00:00Z',
    updatedAt: '2024-05-22T08:00:00Z',
    location: 'Portland, OR',
  },
  {
    id: 'p6',
    title: 'Wilson Tennis Balls (3-pack)',
    description: 'Unopened pack of Wilson tennis balls. Perfect for practice or casual play.',
    price: 8.00,
    condition: 'new',
    images: ['https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c5',
    brandId: 'b1',
    sellerId: 'u3',
    status: 'active',
    createdAt: '2024-05-21T12:30:00Z',
    updatedAt: '2024-05-21T12:30:00Z',
    location: 'Chicago, IL',
  },
  {
    id: 'p7',
    title: 'Yonex Tennis Strings',
    description: 'Professional grade Yonex tennis strings, 16 gauge. Perfect for power players seeking control.',
    price: 15.00,
    condition: 'new',
    images: ['https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c4',
    brandId: 'b6',
    sellerId: 'u1',
    status: 'active',
    createdAt: '2024-05-20T15:45:00Z',
    updatedAt: '2024-05-20T15:45:00Z',
    location: 'Miami, FL',
  },
  {
    id: 'p8',
    title: 'Head Graphene Tennis Racket',
    description: 'Head Graphene tennis racket with excellent power and control. Grip size 4 1/4, recently restrung.',
    price: 125.00,
    condition: 'excellent',
    images: ['https://images.unsplash.com/photo-1593111774240-d529f12cf4bb?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c1',
    brandId: 'b3',
    sellerId: 'u2',
    status: 'active',
    createdAt: '2024-05-19T09:20:00Z',
    updatedAt: '2024-05-19T09:20:00Z',
    location: 'Phoenix, AZ',
  },
  {
    id: 'p9',
    title: 'Nike Tennis Skirt',
    description: 'High-quality Nike tennis skirt, size M. Perfect for matches or practice with built-in shorts.',
    price: 35.00,
    condition: 'like-new',
    images: ['https://images.unsplash.com/photo-1506629905822-b9dc06fe94c7?w=400&h=300&fit=crop&crop=center'],
    categoryId: 'c3',
    brandId: 'b4',
    sellerId: 'u3',
    status: 'active',
    createdAt: '2024-05-18T14:10:00Z',
    updatedAt: '2024-05-18T14:10:00Z',
    location: 'Denver, CO',
  },
];

// Mock Messages
export const mockMessages: Message[] = [
  {
    id: 'm1',
    postId: 'p1',
    senderId: 'u2',
    receiverId: 'u1',
    content: 'Hi! Is this tennis racket still available?',
    timestamp: '2024-05-22T14:30:00Z',
    isRead: false,
  },
  {
    id: 'm2',
    postId: 'p1',
    senderId: 'u1',
    receiverId: 'u2',
    content: 'Yes, it\'s still available! Are you interested?',
    timestamp: '2024-05-22T15:00:00Z',
    isRead: true,
  },
  {
    id: 'm3',
    postId: 'p2',
    senderId: 'u3',
    receiverId: 'u2',
    content: 'What size are these running shoes?',
    timestamp: '2024-05-22T16:15:00Z',
    isRead: false,
  },
];

// Mock Conversations (adding this missing export)
export const mockConversations = [
  {
    id: 'conv1',
    postId: 'p1',
    participantId: 'u2',
    participantName: 'Jane Smith',
    lastMessage: 'Yes, it\'s still available! Are you interested?',
    lastMessageTime: '2024-05-22T15:00:00Z',
    unreadCount: 1,
    isArchived: false,
  },
  {
    id: 'conv2', 
    postId: 'p2',
    participantId: 'u3',
    participantName: 'Mike Johnson',
    lastMessage: 'What size are these running shoes?',
    lastMessageTime: '2024-05-22T16:15:00Z',
    unreadCount: 1,
    isArchived: false,
  },
];

// Helper functions to simulate API calls
export const mockApiDelay = (ms: number = 500) => 
  new Promise(resolve => setTimeout(resolve, ms));

export const getMockUser = async (id: string): Promise<User | null> => {
  await mockApiDelay();
  return mockUsers.find(user => user.id === id) || null;
};

export const getMockPosts = async (filters?: {
  categoryId?: string;
  brandId?: string;
  sellerId?: string;
}): Promise<Post[]> => {
  await mockApiDelay();
  let filteredPosts = mockPosts;
  
  if (filters?.categoryId) {
    filteredPosts = filteredPosts.filter(post => post.categoryId === filters.categoryId);
  }
  if (filters?.brandId) {
    filteredPosts = filteredPosts.filter(post => post.brandId === filters.brandId);
  }
  if (filters?.sellerId) {
    filteredPosts = filteredPosts.filter(post => post.sellerId === filters.sellerId);
  }
  
  return filteredPosts;
};

export const getMockCategories = async (): Promise<Category[]> => {
  await mockApiDelay();
  return mockCategories;
};

export const getMockBrands = async (): Promise<Brand[]> => {
  await mockApiDelay();
  return mockBrands;
};

export const getFeaturedPosts = async (): Promise<Post[]> => {
  await mockApiDelay();
  return mockPosts.filter(post => post.status === 'active').slice(0, 6);
}; 